/**
 * Strokes are `non-scaling-stroke`, so `strokeWidth={1}` paints exactly 1px at whatever
 * size this renders (16px in the toolbar, 18px in a menu row, 20px in the Add menu)
 * instead of thickening with the box.
 */
export default function IconListStars({
  className,
  fill,
  stroke = "currentColor",
}: {
  className?: string
  fill?: string
  stroke?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      strokeWidth={1}
      className={className}
    >
      <g id="List-Stars Streamline Ultimate">
        <path
          id="Vector"
          d="M1.125 9C1.125 11.0886 1.95469 13.0916 3.43153 14.5685C4.90838 16.0453 6.91142 16.875 9 16.875C11.0886 16.875 13.0916 16.0453 14.5685 14.5685C16.0453 13.0916 16.875 11.0886 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125C6.91142 1.125 4.90838 1.95469 3.43153 3.43153C1.95469 4.90838 1.125 6.91142 1.125 9Z"
          fill={fill}
        />
        <path
          id="Vector_2"
          d="M7.125 3.3735H17.625"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M7.125 9.3735H17.625"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M7.125 15.3735H17.625"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M4.125 3.3735H0.375"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M3.375 1.4985L1.125 5.2485"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M1.125 1.4985L3.375 5.2485"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M4.125 9.3735H0.375"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_9"
          d="M3.375 7.4985L1.125 11.2485"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_10"
          d="M1.125 7.4985L3.375 11.2485"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_11"
          d="M4.125 15.3735H0.375"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_12"
          d="M3.375 13.4985L1.125 17.2485"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_13"
          d="M1.125 13.4985L3.375 17.2485"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
